import { getColorBlock, getSolidBackgroundShade, getBackgroundShade, getBorderColor, getDimmedTextColor, createStyleFunction } from 'utils/ui';
function getBackgroundColour(value, theme) {
  if (value === 'shaded') {
    return getSolidBackgroundShade(theme);
  }
  if (value === 'transparently-shaded') {
    return getBackgroundShade(theme);
  }
  if (value === 'border') {
    return getBorderColor(theme);
  }
  if (value === 'dimmed') {
    return getDimmedTextColor(theme);
  }
  return getColorBlock(value, theme);
}
export var themePropsDef = [{
  styleProp: 'textColor',
  properties: ['color'],
  getValue: getColorBlock
}, {
  styleProp: 'background',
  getValue: getBackgroundColour
}, {
  styleProp: 'backgroundColor',
  getValue: getBackgroundColour
}];
export default createStyleFunction(themePropsDef);